import styled from "styled-components";
import { motion } from "framer-motion";

export const Track = styled.div`
  position: relative;
  padding-left: 40px;

  @media (max-width: 600px) {
    padding-left: 28px;
  }
`;

export const LineBase = styled.div`
  position: absolute;
  top: 6px;
  bottom: 6px;
  left: 5px;
  width: 2px;
  background: rgba(255, 255, 255, 0.08);
`;

export const LineProgress = styled(motion.div)`
  position: absolute;
  top: 6px;
  left: 5px;
  width: 2px;
  height: 100%;
  background: ${({ theme }) => theme.gradient};
  transform-origin: top;
`;

export const Item = styled(motion.div)`
  position: relative;
  padding-bottom: 40px;

  &:last-child {
    padding-bottom: 0;
  }
`;

export const Node = styled.div`
  position: absolute;
  top: 6px;
  left: -40px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: ${({ theme }) => theme.bg};
  border: 2px solid ${({ theme }) => theme.primary};
  box-shadow: 0 0 0 4px rgba(139, 124, 255, 0.12);

  @media (max-width: 600px) {
    left: -28px;
  }
`;
